module.exports = __webpack_public_path__ + "static/media/bg_main.b4ec20d7.png";